import { inject, Injectable } from '@angular/core';
// import { HttpClient } from '@microsoft/signalr';
import { AppConfig } from '../config/app.config';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { map, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailDistributionService {


  private apiUrl = AppConfig.apiUrl;
   httpClient = inject(HttpClient);
   
  SendEmailDistribution(payload: any){
    const path=`/api/Policy/DocumentEmailDistribution`
    const encodedPath = encodeURIComponent(path);
    return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload,{responseType: 'text'}).pipe(
       map(response => {
                try {
                  return {success: true, message: response}
                } catch (e) {
                  return { success: false, message: response };
                }
              }),
              catchError((error: HttpErrorResponse) => {
                // You can return a structured error response as well
                return of({ success: false, message: error.error });
              })
    );
  }
}
